import React from 'react';
import type { EditorElement } from '../../../../editor/types';

interface InteractionPanelProps {
  element: EditorElement | null;
  elements: EditorElement[];
  onUpdateData: (elementId: string, data: Record<string, unknown>) => void;
}

const InteractionPanel: React.FC<InteractionPanelProps> = ({ element }) => {
  if (!element) {
    return null;
  }

  // Text elements don't have interactions
  return null;
};

export default InteractionPanel;